query TACompanyCorporatePeriods {
  companyCorporatePeriods(
    filter: { isEntryAllowed: { equalTo: true } }
    orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]
  ) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
}
